import { z } from 'zod';

import type {
  ListScaleTicketsRequest,
  ListScaleTicketsResponse,
} from './list-scale-tickets.dto.js';
import { shipmentFollowUpComparisonStatusValues } from './list-scale-tickets.dto.js';
import { ShipmentScaleTicketSchema } from './shipments-shared.schema.js';

const nonNegativeNumberSchema = z.number().min(0);

export const ListScaleTicketsRequestSchema: z.ZodType<ListScaleTicketsRequest> = z
  .object({
    companyId: z.uuid(),
    shipmentId: z.uuid(),
    stationId: z.uuid(),
  })
  .strict();

export const ScaleTicketsFollowUpSchema = z
  .object({
    expectedSentLb: nonNegativeNumberSchema,
    minimumAcceptableReceivedLb: nonNegativeNumberSchema,
    measuredReceivedLb: nonNegativeNumberSchema.nullable(),
    differenceFromExpectedSentLb: z.number().nullable(),
    differenceFromExpectedSentPct: z.number().nullable(),
    comparisonStatus: z.enum(shipmentFollowUpComparisonStatusValues),
  })
  .strict();

export const ListScaleTicketsResponseSchema: z.ZodType<ListScaleTicketsResponse> = z
  .object({
    scaleTickets: z.array(ShipmentScaleTicketSchema),
    ...ScaleTicketsFollowUpSchema.shape,
  })
  .strict();
